var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.425,7.613,10.387.575a1.96,1.96,0,0,0-2.774,0L.575,7.613a1.962,1.962,0,0,0,0,2.774l7.038,7.038a1.96,1.96,0,0,0,2.774,0l7.038-7.038A1.96,1.96,0,0,0,17.425,7.613Zm-.8,1.979L9.592,16.63a.838.838,0,0,1-1.184,0L1.37,9.592a.838.838,0,0,1,0-1.184L8.408,1.37a.838.838,0,0,1,1.184,0L16.63,8.408a.838.838,0,0,1,0,1.184Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.347,10.832l.339-3.761V4.5H8.314V7.071l.339,3.761Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.495,
    height: 1.527,
    transform: "translate(8.252 11.973)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.e519e079d4b7904e43149fdb78e0583e.svg";